export default {
  user: {
    locked: 'User locked, please contact CIEM',
    coordonne: 'Contact information',
    securite: 'security',
    name: 'Utilisateur',
    search: {},
    details: {
      mail: 'Mail',
      portable: 'Phone',
      question: 'Secret question',
      dateNaissance: 'Date of Birth',
      roleCorrespondant:
        'Check this box ONLY if you are a company correspondent',
    },
    infoPersonnelles: 'Personal informations',
    infoProfessionnelles: 'Professional information',
    infoAdresse: 'Address',
    infoEtablissement: 'Companies',
  },
}
